/**
 * loopTreeUtils.ts — Workflow scoped loop 树辅助判断
 */
import type { SessionTree } from '../../types/tree';

/** 是否已有可渲染的时间线节点（非空 store 壳） */
export function hasTimelineNodes(tree: SessionTree | undefined): boolean {
  if (!tree) return false;
  return tree.rootChildren.length > 0 || Object.keys(tree.byId).length > 0;
}
